import { useState } from "react";
import PermissionAddEdit from "./PermissionAddEdit";
import Button from "../../ui/Button";
import { AddIcon, DeleteIcon, EditIcon } from "../../utils/icon.utils";
import Table from "../../ui/Table/Table";
import { GroupBtn } from "../../ui/GroupBtn";
import {
  useDeletePermissionMutation,
  useGetAllPermissionQuery
} from "../../utils/permission.utils";
import { tableIndex } from "../../utils/table.utils";
import { onConfirm } from "../../utils/sweetAlert.utils";
import Loading from "../../components/Loading";
import PageLayout from "../../layouts/PageLayout";
import { arrayMap } from "../../utils/array.utils";

export default function PermissionPage() {
  const pageSize = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const [editItem, setEditItem] = useState(null);

  const [modal, setModal] = useState(false);

  const toggle = () => {
    if (modal) {
      setEditItem(null);
    }
    setModal((prev) => !prev);
  };

  const { loading, data } = useGetAllPermissionQuery({
    query: `?page=${currentPage}&size=${pageSize}`
  });

  const { loading: deleting, deletePermission } = useDeletePermissionMutation(["deletePermission"]);

  const totalPage = data?.last_page === 1 && data?.total === 0 ? 0 : data?.last_page;

  const breadCrumbs = [
    {
      name: "Settings",
      link: "/settings"
    },
    {
      name: "Permission"
    }
  ];

  const thead = ["#", "Name", "Slug", "Action"];

  const tbody =
    arrayMap(data?.data, (item, index) => ({
      "#": tableIndex(index, currentPage, pageSize),
      Name: item?.name ?? "-",
      Slug: item?.slug ?? "-",
      ...item
    })) || [];

  const ActionComponent = ({ data }) => {
    const handleEdit = (item) => {
      setEditItem(item);
      toggle();
    };

    const handleDelete = async (item) => {
      const { isConfirmed } = await onConfirm();

      if (isConfirmed) {
        await deletePermission(item?.id);
      }
    };

    const btns = [
      {
        icon: DeleteIcon,
        onClick: () => handleDelete(data),
        color: "danger"
      },
      {
        icon: EditIcon,
        onClick: () => handleEdit(data),
        color: "primary"
      }
    ];
    return <GroupBtn btns={btns} justify="start" />;
  };

  const isLoading = loading || deleting;

  return (
    <PageLayout
      title="Permission"
      subTitle={`Total: ${data?.total ?? 0}`}
      breadCrumbs={breadCrumbs}>
      <div className="text-end">
        <Button color="primary" icon={AddIcon} name="Create Permission" onClick={toggle} />
      </div>

      {loading ? "Loading..." : ""}

      <Table
        thead={thead}
        tbody={tbody}
        action={ActionComponent}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        totalPage={totalPage}
      />

      {modal && <PermissionAddEdit modal={modal} toggle={toggle} editItem={editItem} />}
      {<Loading loading={isLoading} />}
    </PageLayout>
  );
}
